import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { DialogData } from '@degreed/apollo-angular';

import { i18n, TranslateFn } from '../data-service';
export interface ConfirmOnLeaveData extends DialogData {
  t: TranslateFn;
  onClose?: (confirmed: boolean) => void;
}

/**
 * If the users navigations and deactivates the Admin Branding page WITH unsaved changes,
 * this modal will appear to confirm publish or discard changes.
 */
@Component({
  selector: 'dgx-org-branding-unpublished-changes-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="tw-max-w-72 tw-rounded-2xl tw-bg-white tw-p-4 tw-shadow-lg md:tw-max-w-md md:tw-p-6 lg:tw-max-w-xl"
      role="dialog"
      aria-labelledby="title"
      aria-describedby="description"
    >
      <div
        class="tw-mb-8 tw-flex tw-flex-col tw-items-start tw-gap-6 md:tw-flex-row"
      >
        <div class="tw-flex tw-flex-col">
          <h4 class="tw-mb-2 tw-font-extrabold tw-text-neutral-900" id="title">
            {{ t('Unpublished Changes', i18n.confirmOnLeave.title) }}
          </h4>
          <p id="description" class="tw-text-neutral-900">
            {{
              t(
                'Leaving this page will discard all of your changes. Would you like to publish the following changes before leaving?',
                i18n.confirmOnLeave.description
              )
            }}
          </p>
          <ul class="tw-mt-4 tw-list-inside tw-list-disc tw-pl-2 tw-text-sm">
            <li>
              {{ t('Navigation Styling', i18n.confirmOnLeave.toNavigation) }}
            </li>
            <li>
              {{ t('Endorsement Image', i18n.confirmOnLeave.toEndorsements) }}
            </li>
            <li>{{ t('Organization Name', i18n.confirmOnLeave.toOrgInfo) }}</li>
          </ul>
        </div>
      </div>
      <div
        class="tw-flex tw-flex-col tw-justify-end tw-gap-2 md:tw-flex-row md:tw-gap-4"
      >
        <button
          class="tw-btn-medium tw-btn-secondary-filled"
          (click)="handleClose(false)"
        >
          {{ t('Discard All Changes', i18n.confirmOnLeave.discardAllChanges) }}
        </button>
        <button
          class="tw-btn-primary tw-btn-medium"
          (click)="handleClose(true)"
        >
          {{ t('Publish', i18n.confirmOnLeave.publish) }}
        </button>
      </div>
    </div>
  `,
})
export class ConfirmOnLeaveModalComponent {
  i18n = i18n; // template access to i18n keys for OrgBranding
  @Input() t: TranslateFn;

  @Output() public close: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    @Inject(DIALOG_DATA)
    public data: ConfirmOnLeaveData
  ) {
    this.t = data.t || ((val: string) => val);
  }

  handleClose(confirmed: boolean): void {
    if (this.data.onClose) {
      this.data.onClose(confirmed);
    }
    this.close.emit(confirmed);
  }
}
